export const graders = [
    {"platslagarsmyg":"799","bockvinkel":"10","grader":"170"},
    {"platslagarsmyg":"798","bockvinkel":"11","grader":"169"},
    {"platslagarsmyg":"798","bockvinkel":"12","grader":"168"},
    {"platslagarsmyg":"797","bockvinkel":"13","grader":"167"},
    {"platslagarsmyg":"796","bockvinkel":"14","grader":"166"},
    {"platslagarsmyg":"796","bockvinkel":"15","grader":"165"},
    {"platslagarsmyg":"795","bockvinkel":"16","grader":"164"},
    {"platslagarsmyg":"795","bockvinkel":"17","grader":"163"},
    {"platslagarsmyg":"794","bockvinkel":"18","grader":"162"},
    {"platslagarsmyg":"794","bockvinkel":"19","grader":"161"},
    {"platslagarsmyg":"793","bockvinkel":"20","grader":"160"},
    {"platslagarsmyg":"792","bockvinkel":"21","grader":"159"},
    {"platslagarsmyg":"791","bockvinkel":"22","grader":"158"},
    {"platslagarsmyg":"791","bockvinkel":"23","grader":"157"},
    {"platslagarsmyg":"790","bockvinkel":"24","grader":"156"},
    {"platslagarsmyg":"789","bockvinkel":"25","grader":"155"},
    {"platslagarsmyg":"788","bockvinkel":"26","grader":"154"},
    {"platslagarsmyg":"787","bockvinkel":"27","grader":"153"},
    {"platslagarsmyg":"786","bockvinkel":"28","grader":"152"},
    {"platslagarsmyg":"785","bockvinkel":"29","grader":"151"},
    {"platslagarsmyg":"784","bockvinkel":"30","grader":"150"},
    {"platslagarsmyg":"783","bockvinkel":"31","grader":"149"},
    {"platslagarsmyg":"782","bockvinkel":"32","grader":"148"},
    {"platslagarsmyg":"781","bockvinkel":"33","grader":"147"},
    {"platslagarsmyg":"780","bockvinkel":"34","grader":"146"},
    {"platslagarsmyg":"779","bockvinkel":"35","grader":"145"},
    {"platslagarsmyg":"778","bockvinkel":"36","grader":"144"},
    {"platslagarsmyg":"777","bockvinkel":"37","grader":"143"},
    {"platslagarsmyg":"776","bockvinkel":"38","grader":"142"},
    {"platslagarsmyg":"775","bockvinkel":"39","grader":"141"},
    {"platslagarsmyg":"774","bockvinkel":"40","grader":"140"},
    {"platslagarsmyg":"773","bockvinkel":"40","grader":"140"},
    {"platslagarsmyg":"772","bockvinkel":"41","grader":"139"},
    {"platslagarsmyg":"771","bockvinkel":"42","grader":"138"},
    {"platslagarsmyg":"770","bockvinkel":"43","grader":"137"},
    {"platslagarsmyg":"769","bockvinkel":"44","grader":"136"},
    {"platslagarsmyg":"768","bockvinkel":"44","grader":"136"},
    {"platslagarsmyg":"767","bockvinkel":"45","grader":"135"},
    {"platslagarsmyg":"766","bockvinkel":"46","grader":"134"},
    {"platslagarsmyg":"765","bockvinkel":"46","grader":"134"},
    {"platslagarsmyg":"764","bockvinkel":"47","grader":"133"},
    {"platslagarsmyg":"763","bockvinkel":"48","grader":"132"},
    {"platslagarsmyg":"762","bockvinkel":"48","grader":"132"},
    {"platslagarsmyg":"761","bockvinkel":"49","grader":"131"},
    {"platslagarsmyg":"760","bockvinkel":"50","grader":"130"},
    {"platslagarsmyg":"759","bockvinkel":"50","grader":"130"},
    {"platslagarsmyg":"758","bockvinkel":"51","grader":"129"},
    {"platslagarsmyg":"757","bockvinkel":"51","grader":"129"},
    {"platslagarsmyg":"756","bockvinkel":"52","grader":"128"},
    {"platslagarsmyg":"755","bockvinkel":"53","grader":"127"},
    {"platslagarsmyg":"754","bockvinkel":"53","grader":"127"},
    {"platslagarsmyg":"753","bockvinkel":"54","grader":"126"},
    {"platslagarsmyg":"752","bockvinkel":"55","grader":"125"},
    {"platslagarsmyg":"751","bockvinkel":"55","grader":"125"},
    {"platslagarsmyg":"750","bockvinkel":"56","grader":"124"},
    {"platslagarsmyg":"749","bockvinkel":"56","grader":"124"},
    {"platslagarsmyg":"748","bockvinkel":"57","grader":"123"},
    {"platslagarsmyg":"747","bockvinkel":"58","grader":"122"},
    {"platslagarsmyg":"746","bockvinkel":"58","grader":"122"},
    {"platslagarsmyg":"745","bockvinkel":"59","grader":"121"},
    {"platslagarsmyg":"744","bockvinkel":"59","grader":"121"},
    {"platslagarsmyg":"743","bockvinkel":"60","grader":"120"},
    {"platslagarsmyg":"742","bockvinkel":"60","grader":"120"},
    {"platslagarsmyg":"741","bockvinkel":"61","grader":"119"},
    {"platslagarsmyg":"740","bockvinkel":"61","grader":"119"},
    {"platslagarsmyg":"739","bockvinkel":"62","grader":"118"},
    {"platslagarsmyg":"738","bockvinkel":"62","grader":"118"},
    {"platslagarsmyg":"737","bockvinkel":"63","grader":"117"},
    {"platslagarsmyg":"736","bockvinkel":"63","grader":"117"},
    {"platslagarsmyg":"735","bockvinkel":"64","grader":"116"},
    {"platslagarsmyg":"734","bockvinkel":"64","grader":"116"},
    {"platslagarsmyg":"733","bockvinkel":"65","grader":"115"},
    {"platslagarsmyg":"732","bockvinkel":"65","grader":"115"},
    {"platslagarsmyg":"731","bockvinkel":"66","grader":"114"},
    {"platslagarsmyg":"730","bockvinkel":"66","grader":"114"},
    {"platslagarsmyg":"729","bockvinkel":"67","grader":"113"},
    {"platslagarsmyg":"728","bockvinkel":"67","grader":"113"},
    {"platslagarsmyg":"727","bockvinkel":"68","grader":"112"},
    {"platslagarsmyg":"726","bockvinkel":"68","grader":"112"},
    {"platslagarsmyg":"725","bockvinkel":"69","grader":"111"},
    {"platslagarsmyg":"724","bockvinkel":"69","grader":"111"},
    {"platslagarsmyg":"723","bockvinkel":"70","grader":"110"},
    {"platslagarsmyg":"722","bockvinkel":"70","grader":"110"},
    {"platslagarsmyg":"721","bockvinkel":"71","grader":"109"},
    {"platslagarsmyg":"720","bockvinkel":"71","grader":"109"},
    {"platslagarsmyg":"719","bockvinkel":"72","grader":"108"},
    {"platslagarsmyg":"718","bockvinkel":"72","grader":"108"},
    {"platslagarsmyg":"717","bockvinkel":"73","grader":"107"},
    {"platslagarsmyg":"716","bockvinkel":"73","grader":"107"},
    {"platslagarsmyg":"715","bockvinkel":"74","grader":"106"},
    {"platslagarsmyg":"714","bockvinkel":"74","grader":"106"},
    {"platslagarsmyg":"713","bockvinkel":"75","grader":"105"},
    {"platslagarsmyg":"712","bockvinkel":"75","grader":"105"},
    {"platslagarsmyg":"711","bockvinkel":"76","grader":"104"},
    {"platslagarsmyg":"710","bockvinkel":"76","grader":"104"},
    {"platslagarsmyg":"709","bockvinkel":"76","grader":"104"},
    {"platslagarsmyg":"708","bockvinkel":"77","grader":"103"},
    {"platslagarsmyg":"707","bockvinkel":"77","grader":"103"},
    {"platslagarsmyg":"706","bockvinkel":"78","grader":"102"},
    {"platslagarsmyg":"705","bockvinkel":"78","grader":"102"},
    {"platslagarsmyg":"704","bockvinkel":"79","grader":"101"},
    {"platslagarsmyg":"703","bockvinkel":"79","grader":"101"},
    {"platslagarsmyg":"702","bockvinkel":"80","grader":"100"},
    {"platslagarsmyg":"701","bockvinkel":"80","grader":"100"},
    {"platslagarsmyg":"699","bockvinkel":"81","grader":"99"},
    {"platslagarsmyg":"698","bockvinkel":"81","grader":"99"},
    {"platslagarsmyg":"697","bockvinkel":"82","grader":"98"},
    {"platslagarsmyg":"696","bockvinkel":"82","grader":"98"},
    {"platslagarsmyg":"695","bockvinkel":"82","grader":"98"},
    {"platslagarsmyg":"694","bockvinkel":"83","grader":"97"},
    {"platslagarsmyg":"693","bockvinkel":"83","grader":"97"},
    {"platslagarsmyg":"692","bockvinkel":"84","grader":"96"},
    {"platslagarsmyg":"691","bockvinkel":"84","grader":"96"},
    {"platslagarsmyg":"690","bockvinkel":"84","grader":"96"},
    {"platslagarsmyg":"689","bockvinkel":"85","grader":"95"},
    {"platslagarsmyg":"688","bockvinkel":"85","grader":"95"},
    {"platslagarsmyg":"687","bockvinkel":"86","grader":"94"},
    {"platslagarsmyg":"686","bockvinkel":"86","grader":"94"},
    {"platslagarsmyg":"685","bockvinkel":"87","grader":"93"},
    {"platslagarsmyg":"684","bockvinkel":"87","grader":"93"},
    {"platslagarsmyg":"683","bockvinkel":"88","grader":"92"},
    {"platslagarsmyg":"682","bockvinkel":"88","grader":"92"},
    {"platslagarsmyg":"681","bockvinkel":"88","grader":"92"},
    {"platslagarsmyg":"680","bockvinkel":"89","grader":"91"},
    {"platslagarsmyg":"679","bockvinkel":"89","grader":"91"},
    {"platslagarsmyg":"678","bockvinkel":"88","grader":"91"},
    {"platslagarsmyg":"677","bockvinkel":"90","grader":"90"},
    {"platslagarsmyg":"676","bockvinkel":"90","grader":"90"},
    {"platslagarsmyg":"675","bockvinkel":"91","grader":"89"},
    {"platslagarsmyg":"674","bockvinkel":"91","grader":"89"},
    {"platslagarsmyg":"673","bockvinkel":"92","grader":"88"},
    {"platslagarsmyg":"672","bockvinkel":"92","grader":"88"},
    {"platslagarsmyg":"671","bockvinkel":"92","grader":"88"},
    {"platslagarsmyg":"670","bockvinkel":"92","grader":"88"},
    {"platslagarsmyg":"669","bockvinkel":"92","grader":"88"},
    {"platslagarsmyg":"668","bockvinkel":"93","grader":"87"},
    {"platslagarsmyg":"667","bockvinkel":"93","grader":"87"},
    {"platslagarsmyg":"666","bockvinkel":"93","grader":"87"},
    {"platslagarsmyg":"665","bockvinkel":"94","grader":"86"},
    {"platslagarsmyg":"664","bockvinkel":"94","grader":"86"},
    {"platslagarsmyg":"663","bockvinkel":"95","grader":"85"},
    {"platslagarsmyg":"662","bockvinkel":"95","grader":"85"},
    {"platslagarsmyg":"661","bockvinkel":"96","grader":"84"},
    {"platslagarsmyg":"660","bockvinkel":"96","grader":"84"},
    {"platslagarsmyg":"659","bockvinkel":"96","grader":"84"},
    {"platslagarsmyg":"658","bockvinkel":"97","grader":"83"},
    {"platslagarsmyg":"657","bockvinkel":"97","grader":"83"},
    {"platslagarsmyg":"656","bockvinkel":"97","grader":"83"},
    {"platslagarsmyg":"655","bockvinkel":"98","grader":"82"},
    {"platslagarsmyg":"654","bockvinkel":"98","grader":"82"},
    {"platslagarsmyg":"653","bockvinkel":"98","grader":"82"},
    {"platslagarsmyg":"652","bockvinkel":"98","grader":"82"},
    {"platslagarsmyg":"651","bockvinkel":"99","grader":"81"},
    {"platslagarsmyg":"650","bockvinkel":"99","grader":"81"},
    {"platslagarsmyg":"649","bockvinkel":"100","grader":"80"},
    {"platslagarsmyg":"648","bockvinkel":"100","grader":"80"},
    {"platslagarsmyg":"647","bockvinkel":"101","grader":"79"},
    {"platslagarsmyg":"646","bockvinkel":"101","grader":"79"},
    {"platslagarsmyg":"645","bockvinkel":"102","grader":"78"},
    {"platslagarsmyg":"644","bockvinkel":"102","grader":"78"},
    {"platslagarsmyg":"643","bockvinkel":"102","grader":"78"},
    {"platslagarsmyg":"642","bockvinkel":"103","grader":"77"},
    {"platslagarsmyg":"641","bockvinkel":"103","grader":"77"},
    {"platslagarsmyg":"640","bockvinkel":"103","grader":"77"},
    {"platslagarsmyg":"639","bockvinkel":"103","grader":"77"},
    {"platslagarsmyg":"638","bockvinkel":"104","grader":"76"},
    {"platslagarsmyg":"637","bockvinkel":"105","grader":"75"},
    {"platslagarsmyg":"636","bockvinkel":"105","grader":"75"},
    {"platslagarsmyg":"635","bockvinkel":"105","grader":"75"},
    {"platslagarsmyg":"634","bockvinkel":"105","grader":"75"},
    {"platslagarsmyg":"633","bockvinkel":"106","grader":"74"},
    {"platslagarsmyg":"632","bockvinkel":"106","grader":"74"},
    {"platslagarsmyg":"631","bockvinkel":"107","grader":"73"},
    {"platslagarsmyg":"630","bockvinkel":"107","grader":"73"},
    {"platslagarsmyg":"629","bockvinkel":"108","grader":"72"},
    {"platslagarsmyg":"628","bockvinkel":"108","grader":"72"},
    {"platslagarsmyg":"627","bockvinkel":"108","grader":"72"},
    {"platslagarsmyg":"626","bockvinkel":"108","grader":"72"},
    {"platslagarsmyg":"625","bockvinkel":"109","grader":"71"},
    {"platslagarsmyg":"624","bockvinkel":"110","grader":"70"},
    {"platslagarsmyg":"623","bockvinkel":"110","grader":"70"},
    {"platslagarsmyg":"622","bockvinkel":"110","grader":"70"},
    {"platslagarsmyg":"621","bockvinkel":"110","grader":"70"},
    {"platslagarsmyg":"620","bockvinkel":"111","grader":"69"},
    {"platslagarsmyg":"619","bockvinkel":"111","grader":"68"},
    {"platslagarsmyg":"618","bockvinkel":"111","grader":"68"},
    {"platslagarsmyg":"617","bockvinkel":"111","grader":"68"},
    {"platslagarsmyg":"616","bockvinkel":"112","grader":"68"},
    {"platslagarsmyg":"615","bockvinkel":"112","grader":"68"},
    {"platslagarsmyg":"614","bockvinkel":"112","grader":"68"},
    {"platslagarsmyg":"613","bockvinkel":"113","grader":"67"},
    {"platslagarsmyg":"612","bockvinkel":"113","grader":"67"},
    {"platslagarsmyg":"611","bockvinkel":"114","grader":"66"},
    {"platslagarsmyg":"610","bockvinkel":"114","grader":"66"},
    {"platslagarsmyg":"609","bockvinkel":"114","grader":"66"},
    {"platslagarsmyg":"608","bockvinkel":"115","grader":"65"},
    {"platslagarsmyg":"607","bockvinkel":"115","grader":"65"},
    {"platslagarsmyg":"606","bockvinkel":"115","grader":"65"},
    {"platslagarsmyg":"605","bockvinkel":"116","grader":"64"},
    {"platslagarsmyg":"604","bockvinkel":"116","grader":"64"},
    {"platslagarsmyg":"603","bockvinkel":"116","grader":"64"},
    {"platslagarsmyg":"602","bockvinkel":"117","grader":"63"},
    {"platslagarsmyg":"601","bockvinkel":"117","grader":"63"},
    {"platslagarsmyg":"600","bockvinkel":"117","grader":"63"},
    {"platslagarsmyg":"599","bockvinkel":"117","grader":"63"},
    {"platslagarsmyg":"598","bockvinkel":"118","grader":"62"},
    {"platslagarsmyg":"597","bockvinkel":"118","grader":"62"},
    {"platslagarsmyg":"596","bockvinkel":"118","grader":"62"},
    {"platslagarsmyg":"595","bockvinkel":"119","grader":"61"},
    {"platslagarsmyg":"594","bockvinkel":"119","grader":"61"},
    {"platslagarsmyg":"593","bockvinkel":"120","grader":"60"},
    {"platslagarsmyg":"592","bockvinkel":"120","grader":"59"},
    {"platslagarsmyg":"591","bockvinkel":"120","grader":"59"},
    {"platslagarsmyg":"590","bockvinkel":"120","grader":"59"},
    {"platslagarsmyg":"589","bockvinkel":"121","grader":"59"},
    {"platslagarsmyg":"588","bockvinkel":"121","grader":"59"},
    {"platslagarsmyg":"587","bockvinkel":"122","grader":"58"},
    {"platslagarsmyg":"586","bockvinkel":"122","grader":"58"},
    {"platslagarsmyg":"585","bockvinkel":"122","grader":"58"},
    {"platslagarsmyg":"584","bockvinkel":"122","grader":"58"},
    {"platslagarsmyg":"583","bockvinkel":"123","grader":"57"},
    {"platslagarsmyg":"582","bockvinkel":"123","grader":"57"},
    {"platslagarsmyg":"581","bockvinkel":"123","grader":"57"},
    {"platslagarsmyg":"580","bockvinkel":"124","grader":"56"},
    {"platslagarsmyg":"579","bockvinkel":"124","grader":"56"},
    {"platslagarsmyg":"578","bockvinkel":"124","grader":"56"},
    {"platslagarsmyg":"577","bockvinkel":"125","grader":"55"},
    {"platslagarsmyg":"576","bockvinkel":"125","grader":"55"},
    {"platslagarsmyg":"575","bockvinkel":"126","grader":"54"},
    {"platslagarsmyg":"574","bockvinkel":"126","grader":"54"},
    {"platslagarsmyg":"573","bockvinkel":"126","grader":"54"},
    {"platslagarsmyg":"572","bockvinkel":"126","grader":"54"},
    {"platslagarsmyg":"571","bockvinkel":"127","grader":"53"},
    {"platslagarsmyg":"570","bockvinkel":"127","grader":"53"},
    {"platslagarsmyg":"569","bockvinkel":"127","grader":"53"},
    {"platslagarsmyg":"568","bockvinkel":"128","grader":"52"},
    {"platslagarsmyg":"567","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"566","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"565","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"564","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"563","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"562","bockvinkel":"129","grader":"51"},
    {"platslagarsmyg":"561","bockvinkel":"130","grader":"50"},
    {"platslagarsmyg":"560","bockvinkel":"130","grader":"50"},
    {"platslagarsmyg":"559","bockvinkel":"130","grader":"50"},
    {"platslagarsmyg":"558","bockvinkel":"131","grader":"49"},
    {"platslagarsmyg":"557","bockvinkel":"131","grader":"48"},
    {"platslagarsmyg":"556","bockvinkel":"131","grader":"48"},
    {"platslagarsmyg":"555","bockvinkel":"132","grader":"48"},
    {"platslagarsmyg":"554","bockvinkel":"132","grader":"48"},
    {"platslagarsmyg":"553","bockvinkel":"132","grader":"48"},
    {"platslagarsmyg":"552","bockvinkel":"133","grader":"47"},
    {"platslagarsmyg":"551","bockvinkel":"133","grader":"47"},
    {"platslagarsmyg":"550","bockvinkel":"133","grader":"47"},
    {"platslagarsmyg":"549","bockvinkel":"133","grader":"47"},
    {"platslagarsmyg":"548","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"547","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"546","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"545","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"544","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"543","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"542","bockvinkel":"134","grader":"46"},
    {"platslagarsmyg":"541","bockvinkel":"135","grader":"45"},
    {"platslagarsmyg":"540","bockvinkel":"135","grader":"45"},
    {"platslagarsmyg":"539","bockvinkel":"135","grader":"45"},
    {"platslagarsmyg":"538","bockvinkel":"136","grader":"44"},
    {"platslagarsmyg":"537","bockvinkel":"136","grader":"44"},
    {"platslagarsmyg":"536","bockvinkel":"","grader":"44"},
    {"platslagarsmyg":"535","bockvinkel":"137","grader":"43"},
    {"platslagarsmyg":"534","bockvinkel":"137","grader":"43"},
    {"platslagarsmyg":"533","bockvinkel":"137","grader":"43"},
    {"platslagarsmyg":"532","bockvinkel":"138","grader":"42"},
    {"platslagarsmyg":"531","bockvinkel":"138","grader":"42"},
    {"platslagarsmyg":"530","bockvinkel":"138","grader":"42"},
    {"platslagarsmyg":"529","bockvinkel":"138","grader":"42"},
    {"platslagarsmyg":"528","bockvinkel":"140","grader":"40"}
    
]
